




















import { Component, Vue } from 'vue-property-decorator';
import { EventBus } from '@/utils/EventBus';
import { Config } from '@/utils/Config';

interface LegendItem {
  color: string;
  text: string;
  circleNotSquare: boolean;
  square: boolean;
  line: boolean;
}

@Component
export default class MapLegend extends Vue {
  private officeLegendItems: LegendItem[] = [];
  private hideLegend: boolean = false;

  mounted() {
    EventBus.$on(Config.MapToggleLegendEvent, this.onSetHideLegend);

    this.officeLegendItems = [
      {
        color: '#ff0000',
        text: this.$t('mapLegend.vo-kontor').toString(),
        circleNotSquare: true,
        square: false,
        line: false,
      },
      {
        color: '#0000ff',
        text: this.$t('mapLegend.regions').toString(),
        circleNotSquare: false, 
        square: true,
        line: false,
      },
      // {
      //   color: '#222;',
      //   text: this.$t('mapLegend.vo').toString(),
      //   circleNotSquare: false,
      //   square: false,
      //   line: true,

      // },
      {
        color: '#00854a' ,
        text: this.$t('mapLegend.sbo').toString(),
        circleNotSquare: false,
        square: false,
        line: true,

      },
    ];
  }

  beforeDestroy() {
    EventBus.$off(Config.MapToggleLegendEvent, this.onSetHideLegend);
  }

  setHideLegend = () => {
    EventBus.$emit(Config.MapToggleLegendEvent)
  }

  private onSetHideLegend() {
    this.hideLegend = this.hideLegend ? false : true;
  }
}
